import React from "react";
import { Box, Chip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { useAppSelector } from "../../app/hooks";
import { seesAdminData } from "../../app/features/auth/authTypes";
import AdminTags from "./AdminTags";

// The line under a stone's name: whether it is still available, then each of its tags — and for an
// admin, the admin tags on the next line, with their editor. Shared so a stone reads the same
// wherever it is introduced.
const DiamondTags = ({ data }: { data: any }) => {
  const role = useAppSelector((state) => state.auth.role);
  const tags: string[] = (data.tags ?? "")
    .split(",")
    .map((tag: string) => tag.trim())
    .filter(Boolean);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          mt: 1,
          flexWrap: "wrap",
        }}
      >
        {data.noLongerAvailable ? (
          <Chip
            size="small"
            color="error"
            icon={<CancelIcon />}
            label="Not available"
          />
        ) : (
          <Chip
            size="small"
            color="success"
            variant="outlined"
            icon={<CheckCircleIcon />}
            label="Available"
          />
        )}
        {tags.map((tag) => (
          <Chip key={tag} size="small" icon={<LocalOfferIcon />} label={tag} />
        ))}
      </Box>
      {seesAdminData(role) && data.id && (
        <AdminTags diamondID={data.id} sku={data.sKU} tags={data.adminTags} />
      )}
    </>
  );
};

export default DiamondTags;
